var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/policy.template.html');

var TheView = GenericView.extend({
    el: '#policy',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "policy");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
        "input .to-validation input": "validateIt",
        "change #select-policy": "enableDisableInput",
        "click #collapseDescription": "collapseDescription"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    enableDisableInput: function(event) {
        var selectValue = $(event.currentTarget).val();

        if ( selectValue == 'SELF_CONSUMPTION') {
            $('#exc_enrg_pr').prop("disabled", false);
            $('#exc_enrg_pr').parent().parent().addClass("to-validation");
        } else {
            $('#exc_enrg_pr').prop("disabled", true);
            $('#exc_enrg_pr').parent().parent().removeClass("to-validation");
        }
    },
    collapseDescription: function(event) {
        var btn = event.currentTarget;
        GenericView.prototype.collapseDescription(btn);
    },
    getAllData: function() {
        var data = {
            policy_type: $("#select-policy").val(),
            add_cost: this.convertToFloat("#add_cost"),
            add_inc: this.convertToFloat("#add_inc"),
            exc_enrg_pr: this.convertToFloat("#exc_enrg_pr")
        };

        return data;
    }


});

module.exports= TheView;